import {
  action$,
  collectRoutines,
  dispatchAction,
  extractPayload,
  ofType,
  routine,
} from '@ardoq/rxbeach';
import { from, switchMap, tap } from 'rxjs';
import {
  fetchImportApiPayloadExamples,
  processImportApiPayloadExamplesResponse,
  processImportApiPayloadExamplesError,
  copyToClipboard,
  setCopiedTab,
} from './actions';
import { importApiPayloadDrawer$ } from './importApiPayloadDrawer$';
import { withLatestFrom } from 'rxjs/operators';
import { payloadToFormattedJsonString } from './utils';
import { handleError, tabularApi } from '@ardoq/api';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { t } from '@ardoq/i18n';
import { translateApiError } from '@ardoq/common-helpers';

export const requestImportApiPayloadExamplesRoutine = action$.pipe(
  ofType(fetchImportApiPayloadExamples),
  extractPayload(),
  withLatestFrom(i18nLocale$),
  switchMap(([payload, i18nLocale]) =>
    from(tabularApi.getImportApiPayloadExamples(payload)).pipe(
      handleError(error => {
        dispatchAction(
          processImportApiPayloadExamplesError({
            message: translateApiError(
              error,
              i18nLocale,
              t(
                i18nLocale,
                'integrations:importApiPayloadDrawer.failedToFetchExamples',
                'Failed to fetch API payload examples'
              )
            ),
            // due to the api package limitation we can't show the valuable message from response.data
            data: error,
          })
        );
      }),
      tap(response =>
        dispatchAction(processImportApiPayloadExamplesResponse(response))
      )
    )
  )
);

const copyToClipboardRoutine = routine(
  ofType(copyToClipboard),
  extractPayload(),
  withLatestFrom(importApiPayloadDrawer$),
  tap(async ([tabType, state]) => {
    if (!state.payload) return;

    try {
      const textToCopy = payloadToFormattedJsonString(
        state.activeTab,
        state.payload
      );
      await navigator.clipboard.writeText(textToCopy);
      dispatchAction(setCopiedTab(tabType));
      setTimeout(() => {
        dispatchAction(setCopiedTab(null));
      }, 2000);
    } catch (err) {
      // silently ignore clipboard errors
    }
  })
);

export const routines = collectRoutines(
  requestImportApiPayloadExamplesRoutine,
  copyToClipboardRoutine
);
